//import React from "react";

const PickListComponentMap={
}

export const getPickListPopup=(pickListPopup)=>{
  return PickListComponentMap[pickListPopup]||null;
};